import React from 'react';

import ForgotPasswordForm from '../components/form/forgotPasswordForm';
import ForgotPasswordConfig from '../screens/ForgotPassword/config';

const ForgotPassword = () => <ForgotPasswordForm screen={ForgotPasswordConfig} />;

export default ForgotPassword;